import { useEffect, useState } from "react";
import { BiWind } from "react-icons/bi";
import { WiHumidity } from "react-icons/wi";
import { TbGauge } from "react-icons/tb";
import { MdVisibility } from "react-icons/md";
import Error from "./Error";

const WeatherDetails = ({ searchCityData }) => {

    const appId = 'd63c5a25fad7cea06ea87aff1138e835';
    const url = 'https://api.openweathermap.org/data/2.5/weather?'
    const [weatherDetails, setWeatherDetails] = useState(null);
    const [showError, setShowError] = useState(false);

    useEffect(() => {

        if (searchCityData != null) {

            const fetchUrl = `${url}lat=${searchCityData.lat}&lon=${searchCityData.long}&appid=${appId}`
            console.log(fetchUrl);

            fetch(fetchUrl)
                .then(response => {
                    if (!response.ok) {
                        setShowError(true);
                        setWeatherDetails(null);
                    }
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    setShowError(false);
                    setWeatherDetails(data);
                })
                .catch(error => {
                    console.log(error.message);
                });
        }
        else {
            setShowError(true);
            setWeatherDetails(null);
        }

    }, [searchCityData]);

    return (
        <div >
            {
                showError && <Error />

            }
            {
                weatherDetails &&
                <div className="weather-details">

                    <h1>{searchCityData.name}</h1>

                    <div className="weather-details-content">
                        <div>
                            <h2>{Math.round(weatherDetails.main.temp - 273)} <span> &#176;</span>C</h2>
                            <h4>{weatherDetails.weather[0].description}</h4>
                        </div>

                        <div>
                            <p>Feels like: {Math.round(weatherDetails.main.feels_like - 273)}  <span> &#176;</span>C</p>
                            <p>Minimum Temp: {Math.round(weatherDetails.main.temp_min - 273)} <span> &#176;</span>C</p>
                            <p>Maximum Temp: {Math.round(weatherDetails.main.temp_max - 273)} <span> &#176;</span>C</p>
                        </div>
                    </div>

                    <div className="weather-details-content-2">
                        <div className="weather-details-content-2-div">
                            <BiWind className="weather-details-content-2-icon" />
                            <p>Wind: {weatherDetails.wind.speed} kmph</p>
                        </div>

                        <div className="weather-details-content-2-div">
                            <WiHumidity className="weather-details-content-2-icon" />
                            <p>Humidity: {weatherDetails.main.humidity}%</p>
                        </div>

                        <div className="weather-details-content-2-div">
                            <TbGauge className="weather-details-content-2-icon" />
                            <p>Pressure: {weatherDetails.main.pressure} hPa</p>
                        </div>

                        <div className="weather-details-content-2-div">
                            <MdVisibility className="weather-details-content-2-icon" />
                            <p>Visibility: {weatherDetails.visibility / 1000} km</p>
                        </div>
                    </div>



                </div>
            }
        </div>
    );
};

export default WeatherDetails;
